import { announcementServiceApi } from "../../app/announcementServiceApi";
import { API_URL } from "../../constants/apiUrl";
import {
  AddCommentBodyType,
  GetCommentResponseType,
  GetQueryArgsType,
  GetSupportDetailsResponseType,
  GetSupportParamsType,
  GetSupportResponseType,
} from "../../types";

export const announcementApi = announcementServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getSupportList: builder.query<
      GetSupportResponseType,
      GetQueryArgsType<GetSupportParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getSupportList,
        ...queryArgs,
      }),
      providesTags: ["GetSupportList"],
    }),
    getSupportDetails: builder.query<GetSupportDetailsResponseType, string>({
      query: (id) => ({
        url: `${API_URL.getSupportDetails}/${id}`,
      }),
      providesTags: (_, __, id) => [{ type: "GetSupportDetails", id }],
    }),
    supportClose: builder.mutation<void, string>({
      query: (id) => ({
        url: `${API_URL.supportClose}/${id}`,
        method: "PATCH",
      }),
      invalidatesTags: (result, _, id) => {
        if (result)
          return [
            "GetSupportList",
            {
              type: "GetSupportDetails",
              id,
            },
          ];

        return [];
      },
    }),
    getComment: builder.query<GetCommentResponseType, string>({
      query: (id) => ({
        url: `${API_URL.getComment}/${id}`,
      }),
      providesTags: (_, __, id) => [{ type: "GetComments", id }],
    }),
    addComment: builder.mutation<void, AddCommentBodyType>({
      query: (body) => ({
        url: API_URL.addComment,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, _, { support_id }) => {
        if (result)
          return [
            {
              type: "GetComments",
              id: support_id,
            },
          ];

        return [];
      },
    }),
  }),
});

export const {
  useGetSupportListQuery,
  useGetSupportDetailsQuery,
  useSupportCloseMutation,
  useGetCommentQuery,
  useAddCommentMutation,
} = announcementApi;
